<section>
  <div class="row" style="margin-top: 15px">
    <div class="col-lg-12">
      <h5 class="text-center">Datas de Atendimento</h5>
      <div class="row" *ngIf="aux;else elseBlock">
        <mat-card
          *ngFor="let item of list_items; let i = index"
          style="margin: 5px; justify-content: center;"
        >
        <mat-card-header>
          <mat-card-title>
            <div class="row" style="justify-content: center">
              <p style="color: rgba(0,0,0,.54);">
                <i class="fas fa-calendar-alt" style="color: #49a28f"></i>
                Data:
                &nbsp;
              </p>
              <p>
                {{ item?.dataentrada | date: 'dd/MM/yyyy' }}
              </p>
            </div>
            <div class="row" style="justify-content: center">
              <p style="color: rgba(0,0,0,.54);">
                <i
                  class="fas fa-stethoscope"
                  style="color: #49a28f"
                ></i>
                Serviço:
                &nbsp;
              </p>
              <p>
                {{ item?.servico?.descricao }}
              </p>
            </div>
          </mat-card-title>
          <mat-card-subtitle>
            Profissional:
            {{ item?.prestador.pessoa.nome | titlecase }}
          </mat-card-subtitle>
        </mat-card-header>
        </mat-card>
      </div>
      <ng-template #elseBlock>
        <div class="col-lg-3" style="margin: auto;">
          <div class="alert alert-info" role="alert">
            <h6 class="text-center">Sem atendimentos!</h6>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</section>
